var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-warning my-3"},[_c('b-spinner',{staticClass:"align-middle"}),_c('br'),_c('strong',[_vm._v("Déconnexion en cours, veuillez patienter...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }